import styled from '@emotion/styled'

export const IconRightWrapper = styled.figure`
  margin-left: auto;
`

export const SubItemsList = styled.ul``
